import React, { useState, useEffect, useRef } from 'react'

type FlashNumberProps = {
    value: number
}

const FlashNumber: React.FC<FlashNumberProps> = ({ value }) => {
    const [flash, setFlash] = useState<'up' | 'down' | null>(null)
    const prevValueRef = useRef<number>(value)

    useEffect(() => {
        if (prevValueRef.current !== value) {
            // Determine if the number went up or down
            if (value > prevValueRef.current) {
                setFlash('up')
            } else if (value < prevValueRef.current) {
                setFlash('down')
            }
            prevValueRef.current = value

            const timeout = setTimeout(() => setFlash(null), 100)
            return () => clearTimeout(timeout)
        }
    }, [value])

    // Tailwind classes for flash effects
    const flashClasses =
        flash === 'up'
            ? 'bg-green-500 text-white'
            : flash === 'down'
            ? 'bg-red-500 text-white'
            : 'bg-gray-100'

    return (
        <div
            className={`font-mono transition-colors duration-100 px-2 rounded-lg ${flashClasses}`}
        >
            {value.toLocaleString()}
        </div>
    )
}

export default FlashNumber
